import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import useScreenType from "react-screentype-hook";
import TabSubscription from "./SettingsModal/TabSubscription";
import TabDocuments from "./SettingsModal/TabDocuments";
import { useGetProfileQuery } from "../../../redux/reducers/apiSlice";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const UpgradeModal = ({ isOpen, onClose }: Props) => {
  const { isMobile } = useScreenType();
  const { data: profile } = useGetProfileQuery();
  const isPaid = profile?.subscription_tier === "PAID";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size={isMobile ? "full" : "xl"}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent className="common-modal-content">
        <ModalCloseButton />
        <ModalHeader>Upgrade</ModalHeader>
        <ModalBody maxHeight="calc(100vh - 179px)">
          <Tabs className="common-tabs-2" defaultIndex={0}>
            <TabList>
              <Tab>Subscription</Tab>
              {isPaid && <Tab>Documents</Tab>}
            </TabList>
            <TabPanels>
              <TabPanel>
                <TabSubscription />
              </TabPanel>
              {isPaid && (
                <TabPanel>
                  <TabDocuments />
                </TabPanel>
              )}
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default UpgradeModal;
